import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectDescriptionSnippets } from 'services/descriptionSnippets/selectors';

// Utils
import orderBy from 'utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface Props {
    schemaAttributeId: number;
}

const selectSchemaAttributeId = (state: any, props: Props) =>
    props.schemaAttributeId;

const selectData = createDeepEqualSelector(
    selectDescriptionSnippets,
    sescriptionSnippetsState => Object.values(sescriptionSnippetsState)
);

const selectFilteredData = createDeepEqualSelector(
    [selectData, selectSchemaAttributeId],
    (dataState, schemaAttributeIdState) =>
        dataState.filter(
            value => value.schemaAttributeId === schemaAttributeIdState
        )
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'id')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    orderedDataState => orderedDataState.map(value => value.text)
);

export { selectData, selectFilteredData, selectOrderedData, selectOptions };
